import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const statCards = [
  { key: "diproses", label: "Sedang Diproses", icon: "pending_actions", color: "warning" },
  { key: "selesai", label: "Layanan Selesai", icon: "task_alt", color: "success" },
  { key: "total_layanan", label: "Jenis Layanan", icon: "description", color: "info" },
  { key: "total_pengajuan", label: "Total Pengajuan", icon: "assignment", color: "dark" },
];

function StatsSection({ statistik, loading }) {
  return (
    <MDBox id="statistik" component="section" py={8} bgColor="grey-100">
      <Container>
        <MDBox textAlign="center" mb={5}>
          <MDTypography variant="h3" fontWeight="bold" mb={1}>
            Statistik Pelayanan
          </MDTypography>
          <MDTypography variant="body2" color="text">
            Transparansi kinerja pelayanan perizinan DPMPTSP Kabupaten Rote Ndao
          </MDTypography>
        </MDBox>

        <Grid container spacing={3} justifyContent="center">
          {statCards.map((item) => (
            <Grid item xs={12} sm={6} lg={3} key={item.key}>
              <Card sx={{ height: "100%", overflow: "visible" }}>
                <MDBox p={3} textAlign="center">
                  <MDBox
                    variant="gradient"
                    bgColor={item.color}
                    color="white"
                    width="3.5rem"
                    height="3.5rem"
                    borderRadius="md"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    mx="auto"
                    mb={2}
                    shadow="md"
                  >
                    <Icon fontSize="medium">{item.icon}</Icon>
                  </MDBox>
                  <MDTypography variant="h3" fontWeight="bold" color={item.color}>
                    {loading ? "..." : statistik?.[item.key] ?? 0}
                  </MDTypography>
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    {item.label}
                  </MDTypography>
                </MDBox>
              </Card>
            </Grid>
          ))}
        </Grid>

        {!loading && statistik?.per_sektor?.length > 0 && (
          <MDBox mt={5}>
            <MDTypography variant="h5" fontWeight="medium" mb={2} textAlign="center">
              Rekapitulasi per Sektor
            </MDTypography>
            <Grid container spacing={2}>
              {statistik.per_sektor.map((row) => (
                <Grid item xs={12} sm={6} md={4} key={row.sektor}>
                  <Card>
                    <MDBox p={2.5}>
                      <MDTypography variant="button" fontWeight="bold" mb={1}>
                        {row.sektor}
                      </MDTypography>
                      <MDBox display="flex" justifyContent="space-between">
                        <MDTypography variant="caption" color="text">
                          Diproses: <strong>{row.diproses}</strong>
                        </MDTypography>
                        <MDTypography variant="caption" color="text">
                          Selesai: <strong>{row.selesai}</strong>
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </MDBox>
        )}
      </Container>
    </MDBox>
  );
}

export default StatsSection;
